// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import storage from './mixins/storage'

Vue.config.productionTip = false

const axiosConfig = {
  baseURL: "https://kerb.portodoitaqui.com", // http://localhost:80  https://kerb.portodoitaqui.com
  timeout: 30000,
};

Vue.prototype.$http = axios.create(axiosConfig)

Vue.directive('visible', function(el, binding) {
  el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});

Vue.filter('formatDate', function(value){
  if (!value) return ''
  let data = new Date(value);
  return `${data.getDate()}/${data.getMonth() + 1}/${data.getFullYear()} às ${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`;
});

Vue.filter('formatDateMinimal', function(value){
  if (!value) return ''
  let data = new Date(value);
  return `${data.getDate()}/${data.getMonth() + 1}/${data.getFullYear().toString().substr(-2)}`;
});

let token = storage.methods.getToken()

 if (token) {
   Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
 }

/* const errorInterceptor = error => {


// check if it's a server error
  if (!error.response) {
    //notify.warn('Network/Server error');
    console.error('**Network/Server error');
    console.log(error.response);
    return Promise.reject(error);
  }

  // all the other error responses
  switch (error.response.status) {

    case 401: // authentication error, logout the user
      console.log(error.response.status, error.message);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      router.push('/login');
      break;

      // case 403: //sem nivel de acesso
      // console.log(error.response.status, error.message);
      // localStorage.removeItem('token');
      // localStorage.removeItem('user');
      // router.push('/login');
      // break;

 }
  return Promise.reject(error);
}*/



Vue.prototype.$http.interceptors.response.use( response => response , error => {

  if (error.response.status === 401) {
    console.log("deu ruim..... sua requisição deu 401 Unauthorized")
    router.push('/login')
    console.info('auth token expired')
    localStorage.clear()
    sessionStorage.clear()
  } else if (error.response.status === 403) {
    console.log("deu ruim..... sua requisição deu 403 Forbiden")
    // router.push('/login')
  } else {
    return Promise.reject(error)
  }

});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js